/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { box, ResetAction, SetValueAction } from 'ngrx-forms';

// IMPORTANT Autogenerated file
import { Injectable } from '@angular/core';
import { Ente } from '@ideapa/app-shared-ente';
import { Modulo } from '@ideapa/app-shared-modulo';
import { LoginResponseDto, TokenDto } from '@ideapa/common-dto';
import { select, Store } from '@ngrx/store';

import { MFAMethodEnum } from '@ideapa/common-utils';
import * as AuthActions from './auth.actions';
import {
  CHANGE_PASSWORD_FORM_ID,
  ChangePasswordFormValue,
  EMAIL_OTP_VERIFY_CODE_FORM_ID,
  emailOtpVerifyCodeFormInitialState,
  EmailOtpVerifyCodeFormValue,
  LOGIN_FORM_ID,
  loginFormInitialState,
  LoginFormValue,
  MA_VERIFY_CODE_FORM_ID,
  MAVerifyCodeFormInitialState,
  MAVerifyCodeFormValue,
  SELECT_MODULO_FORM_ID,
  SelectModuloFormValue,
} from './auth.reducer';
import * as AuthSelectors from './auth.selectors';

@Injectable()
export class AuthFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  selectLoggedUser$ = this.store.pipe(select(AuthSelectors.selectLoggedUser));
  error$ = this.store.pipe(select(AuthSelectors.selectAuthError));

  selectLoginForm$ = this.store.pipe(select(AuthSelectors.selectLoginForm));
  selectAuthError$ = this.store.pipe(select(AuthSelectors.selectAuthError));
  resetPasswordEmailSent$ = this.store.pipe(
    select(AuthSelectors.resetPasswordEmailSent)
  );

  selectUserMustResetPassword$ = this.store.pipe(
    select(AuthSelectors.selectUserMustResetPassword)
  );
  selectForgotPasswordForm$ = this.store.pipe(
    select(AuthSelectors.selectForgotPasswordForm)
  );
  selectResetPasswordForm$ = this.store.pipe(
    select(AuthSelectors.selectResetPasswordForm)
  );
  seletQueryParams$ = this.store.pipe(select(AuthSelectors.selectQueryParams));

  availableModules$ = this.store.pipe(select(AuthSelectors.availableModules));

  modulo$ = this.store.pipe(select(AuthSelectors.modulo));

  ente$ = this.store.pipe(select(AuthSelectors.ente));

  anno$ = this.store.pipe(select(AuthSelectors.anno));

  isAdmin$ = this.store.pipe(select(AuthSelectors.isAdmin));

  selectModuloForm$ = this.store.pipe(
    select(AuthSelectors.getSelectModuloForm)
  );

  selectModuloPartecipataForm$ = this.store.pipe(
    select(AuthSelectors.getSelectModuloPartecipataForm)
  );
  changePasswordForm$ = this.store.pipe(
    select(AuthSelectors.getChangePasswordForm)
  );

  // MFA
  selectVerifyMAForm$ = this.store.pipe(select(AuthSelectors.getVerifyMAForm));
  selectVerifyEmailOtpForm$ = this.store.pipe(
    select(AuthSelectors.getVerifyEmailOtpForm)
  );

  constructor(private store: Store) {}

  loginAAD(rememberMe: boolean) {
    this.store.dispatch(AuthActions.loginWithAAD({ rememberMe }));
  }

  login(
    username: string,
    password: string,
    rememberMe: boolean,
    newPassword: string
  ) {
    this.store.dispatch(
      AuthActions.login({ username, password, rememberMe, newPassword })
    );
  }

  forceRefresh() {
    this.store.dispatch(AuthActions.forceRefresh());
  }

  forceRefreshSuccess(result: TokenDto) {
    this.store.dispatch(AuthActions.forceRefreshSucces({ result }));
  }

  logout() {
    this.store.dispatch(AuthActions.logout());
  }

  checkAADAuth() {
    this.store.dispatch(AuthActions.checkAADAuth());
  }

  getLoggedUser() {
    this.store.dispatch(AuthActions.getLoggedUser());
  }

  sessionExpired() {
    this.store.dispatch(AuthActions.sessionExpired());
  }

  loginFormInitialize() {
    this.store.dispatch(
      new SetValueAction<LoginFormValue>(LOGIN_FORM_ID, loginFormInitialState)
    );
    this.store.dispatch(new ResetAction(LOGIN_FORM_ID));
  }

  loginFormInitializeWithTmpPassword(username: string, password: string) {
    this.store.dispatch(
      new SetValueAction<LoginFormValue>(LOGIN_FORM_ID, {
        username,
        password,
        rememberMe: false,
        newPassword: '',
        confirmPassword: '',
      })
    );
    this.store.dispatch(new ResetAction(LOGIN_FORM_ID));
  }

  MAVerifyCodeFormInitialize() {
    this.store.dispatch(
      new SetValueAction<MAVerifyCodeFormValue>(
        MA_VERIFY_CODE_FORM_ID,
        MAVerifyCodeFormInitialState
      )
    );
    this.store.dispatch(new ResetAction(MA_VERIFY_CODE_FORM_ID));
  }

  EmailVerifyCodeFormInitialize() {
    this.store.dispatch(
      new SetValueAction<EmailOtpVerifyCodeFormValue>(
        EMAIL_OTP_VERIFY_CODE_FORM_ID,
        emailOtpVerifyCodeFormInitialState
      )
    );
    this.store.dispatch(new ResetAction(EMAIL_OTP_VERIFY_CODE_FORM_ID));
  }

  forgotPassword(username: string) {
    this.store.dispatch(AuthActions.forgotPassword({ username }));
  }

  resetPassword(token: string, newPassword: string) {
    this.store.dispatch(AuthActions.resetPassword({ token, newPassword }));
  }

  resetAuthError() {
    this.store.dispatch(AuthActions.resetAuthError());
  }

  selectModulo(modulo: Modulo, prevModulo: Modulo | null) {
    this.store.dispatch(AuthActions.selectModulo({ modulo, prevModulo }));
  }

  showSelectModuloPopup(modulo: Modulo | null) {
    this.store.dispatch(AuthActions.showSelectModuloPopup({ modulo }));
  }

  clearModulo() {
    this.store.dispatch(AuthActions.clearModulo());
  }

  selectEnte(ente: Ente, prevEnte: Ente | null) {
    this.store.dispatch(AuthActions.selectEnte({ ente, prevEnte }));
  }

  selectAnno(anno: number, prevAnno: number | null) {
    this.store.dispatch(AuthActions.selectAnno({ anno, prevAnno }));
  }

  initSelectModuloForm(ente: Ente | null, anno: number) {
    this.store.dispatch(
      new SetValueAction<SelectModuloFormValue>(SELECT_MODULO_FORM_ID, {
        ente: box(ente || undefined),
        anno: anno,
      })
    );
    this.store.dispatch(new ResetAction(SELECT_MODULO_FORM_ID));
  }

  showChangePasswordPopup() {
    this.store.dispatch(
      new SetValueAction<ChangePasswordFormValue>(CHANGE_PASSWORD_FORM_ID, {
        password: '',
        newPassword: '',
        confirmPassword: '',
      })
    );

    this.store.dispatch(new ResetAction(CHANGE_PASSWORD_FORM_ID));

    this.store.dispatch(AuthActions.showChangePasswordPopup());
  }

  changePassword(password: string, newPassword: string) {
    this.store.dispatch(AuthActions.changePassword({ password, newPassword }));
  }

  // MFA
  proceedToMFAMethod(method: MFAMethodEnum, loginResponse: LoginResponseDto) {
    this.store.dispatch(
      AuthActions.proceedToMFAMethod({
        loginData: loginResponse.loginData,
        method: method,
        loginResponse: loginResponse,
      })
    );
  }

  proceedToVerifyMA(loginResponse: LoginResponseDto) {
    this.store.dispatch(AuthActions.insertMAOTP({ result: loginResponse }));
  }

  verifyMAOTP(otpCode: string, loginResponse: LoginResponseDto) {
    this.store.dispatch(
      AuthActions.verifyMAOTP({
        otpCode: otpCode,
        loginResponse: loginResponse,
      })
    );
  }

  verifyEmailOTP(otpCode: string, loginResponse: LoginResponseDto) {
    this.store.dispatch(
      AuthActions.verifyEmailOTP({
        otpCode: otpCode,
        loginResponse: loginResponse,
      })
    );
  }

  missingLoginResponse() {
    this.store.dispatch(AuthActions.missingLoginResponse());
  }
}
